import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

export const Wrapper = styled.div`
	background: ${palette('white')};
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);
	border-radius: 16px;
	padding: 12px;
`;

export const Subheading = styled(Text).attrs({
	color: 'gray5',
	size: FontSizes.sm,
	weight: FontWeights.Medium,
	el: 'h2',
})`
	margin-top: 0;
	margin-bottom: 12px;
`;

export const Fact = styled.p`
	color: ${palette('gray7')};
	margin-bottom: 0;
`;
